import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Check } from "lucide-react";
import api, { extractAxiosError } from "../../lib/api";
import { useAuth } from "../../contexts/AuthContext";

export default function QuotingRulesSection() {
  const { t } = useTranslation();
  const { user, refresh } = useAuth();
  const [value, setValue] = useState(user?.swiss_max_diameter_mm ?? "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setDone(false); setBusy(true);
    try {
      const v = value === "" ? 0 : parseFloat(value);
      if (Number.isNaN(v) || v < 0 || v > 200) throw new Error(t("settings.swissThresholdInvalid"));
      await api.patch("/me/profile", { swiss_max_diameter_mm: v });
      await refresh();
      setDone(true);
    } catch (err) {
      setError(err.response ? extractAxiosError(err, t("common.loadingError")) : err.message);
    }
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="quoting-rules-section">
      <div>
        <label className="label-tech block mb-2">{t("settings.swissThresholdLabel")}</label>
        <div className="flex items-center gap-2">
          <input
            type="number" min="0" max="200" step="0.5"
            value={value}
            onChange={(e) => { setValue(e.target.value); setDone(false); }}
            placeholder="32"
            className="w-32 px-4 py-2.5 rounded-md text-sm font-mono-data bg-slate-900 border border-slate-700 text-slate-100 focus:outline-none focus:border-blue-500"
            data-testid="swiss-threshold-input"
          />
          <span className="text-sm text-slate-400">mm</span>
        </div>
        <p className="text-xs text-slate-500 mt-2">{t("settings.swissThresholdHelp")}</p>
      </div>
      {error && <div className="p-3 rounded-md bg-red-500/10 border border-red-500/40 text-red-300 text-sm" data-testid="quoting-rules-error">{error}</div>}
      <div className="flex items-center gap-3">
        <button type="submit" disabled={busy} className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm disabled:opacity-50" data-testid="swiss-threshold-save-btn">
          {busy ? t("common.loading") : t("settings.profileSave")}
        </button>
        {done && (
          <span className="text-xs text-emerald-400 flex items-center gap-1" data-testid="quoting-rules-saved">
            <Check size={12}/> {t("settings.profileSaved")}
          </span>
        )}
      </div>
    </form>
  );
}
